/**
 * @fileoverview Organisation details query hook.
 * @description Reads the organisation's legal, billing and bank details (GET
 * /sales/organisation-details). Not retried: a `409 / 4120` means they were never saved, which the
 * dialog shows as an empty form rather than a failure, and a refusal will not change on retry.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Anshul Rokde
 */

import { useQuery } from '@tanstack/react-query'

import { SALES_CRM_QUERY_KEYS } from '@/features/sales/constants/prospects-query-keys.constants'
import { getOrganisationDetails } from '@/features/sales/services/organisation-details.service'

/**
 * @description Fetches the organisation details.
 * @param {boolean} enabled - Whether to fetch (the dialog is open).
 * @returns {ReturnType<typeof useQuery>} The query (data is the details and their version).
 */
export function useOrganisationDetails(enabled: boolean) {
  return useQuery({
    queryKey: SALES_CRM_QUERY_KEYS.organisationDetails,
    queryFn: getOrganisationDetails,
    enabled,
    retry: false,
  })
}
